export const BANNER_LINK_TYPES = ['outlet', 'promotions', 'price_match_collection', 'external', 'none'];

/** Canonical storefront path for Hotpoint Price Match landing. */
export const PRICE_MATCH_LANDING_PATH = '/outlets/hotpoint/price-match';

export function outletSlugFromName(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['']/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function getOutletPathSlug(outlet) {
  if (!outlet) return '';
  const slug = outlet.slug || outletSlugFromName(outlet.name);
  if (slug) return slug;
  return String(outlet._id || outlet.id || '');
}

function isPriceMatchLandingPath(link) {
  const path = String(link || '')
    .trim()
    .replace(/^https?:\/\/[^/]+/i, '')
    .split(/[?#]/)[0]
    .replace(/\/+$/, '');
  return (
    path === PRICE_MATCH_LANDING_PATH ||
    path === '/hotpoint/price-match'
  );
}

export function inferLinkTypeFromLegacy(slide) {
  const link = String(slide?.link || '').trim();
  if (!link || link === '#') return 'none';
  if (link === '/deals') return 'promotions';
  if (isPriceMatchLandingPath(link)) return 'price_match_collection';
  const outletMatch = link.match(/^\/outlets\/([^/?#]+)/i);
  if (outletMatch) return 'outlet';
  if (/^https?:\/\//i.test(link)) return 'external';
  return 'external';
}

export function inferLinkTargetFromLegacy(slide, linkType) {
  if (linkType === 'outlet') {
    const match = String(slide?.link || '').match(/^\/outlets\/([^/?#]+)/i);
    return match ? match[1] : '';
  }
  if (linkType === 'external') {
    return String(slide?.link || '').trim();
  }
  return '';
}

export function normalizeSlideLinkFromApi(slide) {
  const linkType = slide?.linkType || inferLinkTypeFromLegacy(slide);
  const safeType = BANNER_LINK_TYPES.includes(linkType) ? linkType : 'none';
  return {
    ...slide,
    linkType: safeType,
    linkTarget:
      slide?.linkTarget != null && String(slide.linkTarget).trim() !== ''
        ? String(slide.linkTarget).trim()
        : inferLinkTargetFromLegacy(slide, safeType),
  };
}

export function resolveOutletPath(linkTarget) {
  const target = String(linkTarget || '').trim();
  if (!target) return null;
  if (target.startsWith('/outlets/')) return target;
  return `/outlets/${target.replace(/^\/+|\/+$/g, '')}`;
}

export function resolveSlideHref(slide) {
  const normalized = normalizeSlideLinkFromApi(slide);
  const { linkType, linkTarget } = normalized;

  if (linkType === 'none') return null;
  if (linkType === 'promotions') return '/deals';
  if (linkType === 'price_match_collection') return PRICE_MATCH_LANDING_PATH;
  if (linkType === 'outlet') return resolveOutletPath(linkTarget);
  if (linkType === 'external') {
    const url = String(linkTarget || normalized.link || '').trim();
    return url || null;
  }
  return null;
}

export function isSlideLinkExternal(slide) {
  return normalizeSlideLinkFromApi(slide).linkType === 'external';
}

export function showDesktopCta(slide) {
  return Boolean(String(slide?.cta || '').trim()) && slide?.ctaDesktopVisible !== false;
}

export function showMobileCta(slide) {
  return Boolean(String(slide?.cta || '').trim()) && slide?.ctaMobileVisible !== false;
}

export function isSlideImageClickable(slide, isMobileView) {
  if (!resolveSlideHref(slide)) return false;
  const cta = String(slide?.cta || '').trim();
  if (!cta) return true;
  return isMobileView ? !showMobileCta(slide) : !showDesktopCta(slide);
}

export function shouldUseLegacyPromotionClick(slide, bannerIsPromotion) {
  if (resolveSlideHref(slide)) return false;
  if (slide.linkType === 'none') return false;
  if (!slide.linkType) {
    const link = String(slide.link || '').trim();
    if (link && link !== '#') return false;
    return Boolean(bannerIsPromotion);
  }
  return false;
}
